import { SimState, makeInitialState } from '../game/simulation';

const KEY = 'sky-farm-tycoon@v12';
const LEGACY_KEYS = [
  'sky-farm-tycoon@v11', 'sky-farm-tycoon@v10', 'sky-farm-tycoon@v9',
  'sky-farm-tycoon@v8',  'sky-farm-tycoon@v7',  'sky-farm-tycoon@v6',
];
const VERSION = 12;
/** Saves older than this can't be migrated forward (too much divergence). */
const MIN_LOADABLE_VERSION = 6;

export class Save {
  read(): SimState | null {
    try {
      // Try the current key first, then fall back to legacy keys (v6 etc.)
      // so a v6 save is picked up by the Sim constructor's migration path
      // (which doubles sub-cell coords on the 16×16 grid + backfills the
      // new free-tile arrays). This preserves the player's data across
      // the v6 → v7 upgrade.
      let raw = localStorage.getItem(KEY);
      if (!raw) {
        for (const k of LEGACY_KEYS) {
          raw = localStorage.getItem(k);
          if (raw) break;
        }
      }
      if (!raw) return null;
      const data = JSON.parse(raw) as SimState;
      const v = data.version ?? 0;
      if (v < MIN_LOADABLE_VERSION) return null;   // too old, reset
      if (v > VERSION) return null;                // future save (downgrade)
      return data;
    } catch {
      return null;
    }
  }

  write(state: SimState) {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (err) {
      console.warn('Save failed', err);
    }
  }

  clear() { localStorage.removeItem(KEY); }

  /** Loads from storage, falling back to a fresh initial state. */
  loadOrNew(): SimState {
    return this.read() ?? makeInitialState();
  }
}
